export const CEDE_LANGUAGES = {
  ENGLISH: "english",
};

export const CEDE_LANGUAGE_LABELS = {
  [CEDE_LANGUAGES.ENGLISH]: "English",
};

export const DEFAULT_LANGUAGE = CEDE_LANGUAGES.ENGLISH;
